import React from 'react';
import { useHistory } from 'react-router';
import './Button.scss';

interface Props {
  className?: string;
  click?: () => void;
  path?: string;
}

const Button: React.FC<Props> = ({ children, className, click, path }) => {
  const history = useHistory();
  
  const classArray = () => {
    return className ? className : "button default-button"
  }
  const handleClick = (event: React.MouseEvent) => {
    event.preventDefault();
    if (click) click();

    if (!path) return;
    history.push(path);
  };

  return <a href={path ? path : ""} className={classArray()} onClick={e => handleClick(e)}> { children } </a>;
};

export default Button;
